import { Navigate, Route } from 'react-router';

import { ReportPaths } from '../paths/ReportPaths';

import { Overview } from '../components/Overview';
import { Paths } from '../pages/Paths';
import { PathView } from '../pages/PathView';
import { Confusions } from '../pages/Confusions';
import { PathBreakdown } from '../components/PathBreakdown';

const LayoutRoute = Route;

export const ReportRoutes = (
  <>
    <Route path={ReportPaths.reportOverview} element={<Overview />} />

    <Route path={ReportPaths.confusions} element={<Confusions />} />
    <LayoutRoute path={ReportPaths.participants}>
      <Route path=":type" element={<Paths />} />
    </LayoutRoute>
    <LayoutRoute path={ReportPaths.paths}>
      <LayoutRoute path=":type">
        <LayoutRoute path=":pathId">
          <Route path="breakdown" element={<PathBreakdown />} />
          <Route path=":viewId" element={<PathView />} />
        </LayoutRoute>
      </LayoutRoute>
    </LayoutRoute>

    <Route index element={<Navigate to={ReportPaths.reportOverview} />} />
    <Route path="*" element={<Navigate to={ReportPaths.reportOverview} />} />

    <Route path="*" element={<Navigate to={ReportPaths.access} />} />
  </>
);
